import React, { useState, useEffect } from "react";

const CustomerLeftPanel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = ["/login.png", "/login.png", "/login.png"];

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      };
    
      const prevSlide = () => {
        setCurrentIndex(
          (prevIndex) => (prevIndex - 1 + images.length) % images.length
        );
      };
      useEffect(() => {
        const interval = setInterval(nextSlide, 3000); // Change slide every 3 seconds
        return () => clearInterval(interval); // Cleanup on component unmount
      }, []);
    const slides = [
        {
          id: 1,
          image: "/slider-1.png",
          text1: " Start your",
          text2: "investment journey",
        },
        {
          id: 2,
          image: "/slider-2.png",
          text1: "Unlock your",
          text2: "financial potential",
        },
        {
          id: 3,
          image: "/slider-3.png",
          text1: "Start your",
          text2: "investment journey",
        },
      ];
  return (
    <div className="relative hidden overflow-hidden lg:flex w-1/2 h-screen">
    {slides.map((slide, index) => (
      <div
        key={slide.id}
        className={`absolute w-full bg-black text-white bg-opacity-100 inset-0 transition-all duration-700 ease-in-out ${
          index === currentIndex
            ? "opacity-100 scale-80"
            : "opacity-0 scale-60"
        }`}
      >
        <img
          src={slide.image}
          alt={slide.text1}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-10">
          <img src="/Caprock-Logo1.svg" alt="Logo" className="h-auto" />
        </div>
        <div
          className={`absolute absolute bottom-15  text-white text-lg left-10 transition-all duration-700 ease-in-out ${
            index === currentIndex ? "bottom-20" : "-bottom-20 opacity-0"
          }`}
        >
          <h1 className="text-4xl font-light text-white">
            {slide.text1}
            <br />
            {slide.text2}
            <br />
            with <span className="italic font-medium">Caprock</span>
          </h1>
          {/* <h1 className="mb-4 font-light text-4xl leading-none">
            {slide.textHeading} <span className="font-medium italic">Caprock</span>
          </h1> */}
          <p className="text-lg font-normal text-white">
            Join Caprock today and start investing
            <br />
            with <span className="italic font-medium">0 commission*</span>
          </p>
          <a href="#" className="text-blue-500 learn-more hover:underline">
            Learn more
          </a>{" "}
        </div>
      </div>
    ))}
    <div className="absolute bottom-12 left-10 flex space-x-2">
      {images.map((image, index) => (
        <div
          key={index}
          className={`h-1 rounded-full transition-all duration-700 ${
            index === currentIndex ? "bg-[#005A9C] w-10" : "bg-white w-5"
          } cursor-pointer`}
          onClick={() => setCurrentIndex(index)}
        />
      ))}
    </div>
    <div className="absolute bottom-12 right-10 flex items-center space-x-4">
      <button
        className="text-3xl opacity-50  text-gray-400 cursor-pointer hover:opacity-100 transition-all duration-300"
        onClick={prevSlide}
      >
        <img src="/arrow-left-slider.svg" alt="Arrow" className="w-6 h-6" />{" "}
      </button>
      <button
        className="text-2xl opacity-50 text-gray-400 cursor-pointer hover:opacity-100 transition-all duration-300"
        onClick={nextSlide}
      >
        <img
          src="/arrow-right-slider.svg"
          alt="Arrow"
          className="w-6 h-6"
        />{" "}
      </button>
    </div>
  </div>
  );
};
export default CustomerLeftPanel;
